import Axios from 'axios';
import * as TokenHelpers from '../utils/tokenHelpers';
import * as ApiHelper from '../utils/apiHelper';

export function authenticate(data) {

  console.log("login data", data);
  let path = ApiHelper.API_ROOT+'/authenticate';
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true);
    Axios({
      url: path,
      method: 'post',
      data: data,
      headers: headers
    })
    .then(function(response) {
      let userData = response.data;
      TokenHelpers.store(userData.token);
      resolve(userData.user);
    }).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function fbAuthenticate(data) {


  let path = ApiHelper.API_ROOT+'/customers/fbauthenticate';
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true);
    Axios({
      url: path,
      method: 'post',
      data: data,
      headers: headers
    })
    .then(function(response) {
      // console.log("fbauthenticate success",response.data);
      let userData = response.data;
      TokenHelpers.store(userData.token);
      resolve(userData.user);
    }).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function googleAuthenticate(data) {


  let path = ApiHelper.API_ROOT+'/customers/googleauthenticate';
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true);
    Axios({
      url: path,
      method: 'post',
      data: data,
      headers: headers
    })
    .then(function(response) {
      // console.log("googlelogin success",response.data);
      let userData = response.data;
      TokenHelpers.store(userData.token);
      resolve(userData.user);
    }).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function getProfile() {

  let path = ApiHelper.API_ROOT+'/customers';
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    Axios({
      url: path,
      method: 'get',
      headers: headers
    })
    .then(function(response) {
      console.log("profile get success", response.data);
      resolve(response.data);
    }).catch(ApiHelper.handleUserAuth).catch(function(error) {
      console.log("profile get error", error.response);
      reject({error: error.response.data})
    });
  });
}

export function updateProfile(data) {

  let path = ApiHelper.API_ROOT+'/customers';
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    Axios({
      url: path,
      method: 'put',
      data: data,
      headers: headers
    })
    .then(function(response) {
      console.log("profile update success", response.data);
      resolve(response.data);
    }).catch(ApiHelper.handleUserAuth).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function changePassword(data) {

  let path = ApiHelper.API_ROOT+'/forgotPassword';
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    Axios({
      url: path,
      method: 'post',
      data: data,
      headers: headers
    })
    .then(function(response) {
      console.log("password change success", response.data);
      resolve(response.data);
    }).catch(ApiHelper.handleUserAuth).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function resetPasswordRequest(data) {

  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true);
    Axios({
      url: `${ApiHelper.API_ROOT}/forgotPassword?email=${data}`,
      method: 'get',
      headers: headers
    })
    .then(function(response) {
      console.log("password reset request success", response.data);
      resolve(response.data);
    }).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function resetPassword(data) {

  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true);
    Axios({
      url: `${ApiHelper.API_ROOT}/forgotPassword`,
      method: 'post',
      data: data,
      headers: headers
    })
    .then(function(response) {
      console.log("password reset success", response.data);
      resolve(response.data);
    }).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function verifyEmail(data) {
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true);
    Axios({
      url: `${ApiHelper.API_ROOT}/verifyEmail`,
      method: 'post',
      data: data,
      headers: headers
    })
    .then(function(response) {
      resolve(response.data);
    }).catch(function(error) {
      reject({error: error.response.data});
    });
  });
}

export function verifyOTPSMS(data) {
  return new Promise((resolve, reject) => {

    let headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    
    Axios({
      url: `${ApiHelper.API_ROOT}/customers/verify-otp-sms?code=${data.otp}`,
      method: 'post',
      // data: data,
      headers: headers
    })
    .then(function(response) {
      resolve(response.data);
    }).catch(function(error) {
      reject({error: error.response.data});
    });
  });
}

export function resendVerifyOTPSMS(data) {
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    Axios({
      url: `${ApiHelper.API_ROOT}/customers/resend-otp-sms`,
      method: 'post',
      // data: data,
      headers: headers
    })
    .then(function(response) {
      resolve(response.data);
    }).catch(function(error) {
      reject({error: error.response.data});
    });
  });
}

export function sendVerifyEmail(data) {
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    Axios({
      url: `${ApiHelper.API_ROOT}/resendVerificationEmail`,
      method: 'post',
      data: data,
      headers: headers
    })
    .then(function(response) {
      resolve(response.data);
    }).catch(function(error) {
      reject({error: error.response.data});
    });
  });
}

export function createNewUser(data) {

  let path = ApiHelper.API_ROOT+'/customers';
  return new Promise((resolve, reject) => {
    Axios({
      url: path,
      method: 'post',
      data
    })
    .then(function(response) {
      console.log("profile created success", response.data);
      let userData = response.data;
      TokenHelpers.store(userData.token);
      resolve(userData.user);
    }).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function createGoogleLogin(data) {

  let path = ApiHelper.API_ROOT+'/customers/googlesignup';
  return new Promise((resolve, reject) => {
    Axios({
      url: path,
      method: 'post',
      data
    })
    .then(function(response) {
      
      let userData = response.data;
      TokenHelpers.store(userData.token);
      resolve(userData.user);
    }).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function createFBLogin(data) {

  let path = ApiHelper.API_ROOT+'/customers/fbsignup';
  return new Promise((resolve, reject) => {
    Axios({
      url: path,
      method: 'post',
      data
    })
    .then(function(response) {
      let userData = response.data;
      TokenHelpers.store(userData.token);
      resolve(userData.user);
    }).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function newsletter(data){
  let path = ApiHelper.API_ROOT+'/newsletter';
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true);
    Axios({
      url: path,
      method: 'post',
      data: data,
      headers: headers
    })
    .then(function(response) {
      resolve(response.data);
    }).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function addAddress(data){
  return new Promise((resolve, reject) => {
    Axios({
      url: `${ApiHelper.API_ROOT}/customers/addresses`,
      method: 'post',
      data: data,
      headers: ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve())
    })
    .then(function(response) {
      resolve(response.data);
    }).catch(ApiHelper.handleUserAuth).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function deleteAddress(data){
  return new Promise((resolve, reject) => {
    Axios({
      url: `${ApiHelper.API_ROOT}/customers/addresses`,
      method: 'delete',
      data: data,
      headers: ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve())
    })
    .then(function(response) {
      resolve(response.data);
    }).catch(ApiHelper.handleUserAuth).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function updateAddress(data){
  return new Promise((resolve, reject) => {
    Axios({
      url: `${ApiHelper.API_ROOT}/customers/addresses`,
      method: 'put',
      data: data,
      headers: ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve())
    })
    .then(function(response) {
      resolve(response.data);
    }).catch(ApiHelper.handleUserAuth).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}



// WEBPACK FOOTER //
// ./src/services/users.js